<template>
  <div>
    <aha-logo
      class="mt-10 mb-8"
      width="120"
      height="26"
    />
    <div v-if="!pptSubmitedRequestAccess">
      <h3 class="text-xl mb-6">
        {{ $i18nPresenter.t('You need access to view this slide') }}
      </h3>
      <p class="mb-6">
        {{ $i18nPresenter.t('This slide comes from an AhaSlides presentation.') }}
      </p>
      <p class="mb-6">
        {{ $i18nPresenter.t('Your account') }}
        <b> {{ email }}</b> {{ $i18nPresenter.t("doesn't have permission to view or present it yet.") }}
      </p>
      <p class="mb-1">
        {{ $i18nPresenter.t('You can:') }}
      </p>
      <ul class="mb-6">
        <li class="mb-1">
          {{ $i18nPresenter.t('Request access from the presentation owner') }}
        </li>
        <li class="mb-1">
          {{ $i18nPresenter.t('Or switch to another account that has access') }}
        </li>
      </ul>
    </div>
    <div v-else>
      <h3 class="text-xl mb-6">
        {{ $i18nPresenter.t('Request sent') }}
        <i class="far fa-check-circle ml-2" />
      </h3>
      <p class="mb-6">
        {{ $i18nPresenter.t("You'll see this slide once the owner approves.") }} <br>
        {{ $i18nPresenter.t('If it still doesn’t load, just reopen the PowerPoint file.') }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    email: {
      type: String,
      default: '',
    },
    pptSubmitedRequestAccess: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  list-style: disc;
  padding-left: 26px;
}

.fa-check-circle {
  color: #33C173;
}
</style>
